type ClxArgument = string | false | undefined;
// utility function for conditionally concatenating class names.
export const clx = (...args: ClxArgument[]) => args.filter((a) => a).join(" ");
